export enum MapMode {
    OpenExisting = "open_existing",
    OpenOrCreate = "open_or_create",
    CreateNew = "create_new"
}
